import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SpinnerDemo from './SpinnerDemo';
import ClientProvider from './client';
export default createDemo(import.meta.url, SpinnerDemo, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/number-field/demos/spinner-demo/SpinnerDemo.tsx",
    "fileName": "SpinnerDemo.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport NumberSpinner from './NumberSpinner';\n\nexport default function SpinnerDemo() {\n  return (\n    <Box\n      sx={{\n        display: 'flex',\n        flexDirection: 'column',\n        gap: 4,\n        justifyContent: 'center',\n      }}\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <NumberSpinner label=\"Number Spinner\" min={10} max={40} />\n      <NumberSpinner label=\"Number Spinner (Small)\" size=\"small\" />\n      <NumberSpinner\n        label=\"Spinner with Error\"\n        min={10}\n        max={40}\n        defaultValue={100}\n        size=\"small\"\n        error\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 27,
        "focusedLines": 10,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport NumberSpinner from './NumberSpinner';\n\nexport default function SpinnerDemo() {\n  return (\n    <Box\n      sx={{\n        display: 'flex',\n        flexDirection: 'column',\n        gap: 4,\n        justifyContent: 'center',\n      }}\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <NumberSpinner label=\"Number Spinner\" min={10} max={40} />\n      <NumberSpinner label=\"Number Spinner (Small)\" size=\"small\" />\n      <NumberSpinner\n        label=\"Spinner with Error\"\n        min={10}\n        max={40}\n        defaultValue={100}\n        size=\"small\"\n        error\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "NumberSpinner"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Number Spinner",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "min"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "10"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "max"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "40"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "NumberSpinner"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Number Spinner (Small)",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "NumberSpinner"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Spinner with Error",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "min"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "10"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "max"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "40"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "100"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "error"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            "      />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 27,
    "focusedLines": 10,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@base-ui/react/number-field",
      "@mui/material/Button",
      "@mui/material/FormControl",
      "@mui/material/FormLabel",
      "@mui/icons-material/Add",
      "@mui/icons-material/Remove",
      "@mui/material/OutlinedInput",
      "@mui/icons-material/OpenInFull"
    ],
    "extraFiles": {
      "NumberSpinner.tsx": {
        "fallback": [
          [
            "span",
            "frame",
            "import * as React from 'react';\nimport { NumberField as BaseNumberField } from '@base-ui/react/number-field';\nimport Box from '@mui/material/Box';\nimport Button from '@mui/material/Button';\nimport FormControl from '@mui/material/FormControl';\nimport FormLabel from '@mui/material/FormLabel';\nimport AddIcon from '@mui/icons-material/Add';\nimport RemoveIcon from '@mui/icons-material/Remove';\nimport OutlinedInput from '@mui/material/OutlinedInput';\nimport OpenInFullIcon from '@mui/icons-material/OpenInFull';\n\nexport default function NumberSpinner({\n  id: idProp,\n  label,\n  error,\n  size = 'medium',\n  ...other\n}: BaseNumberField.Root.Props & {\n  label?: React.ReactNode;\n  size?: 'small' | 'medium';\n  error?: boolean;\n}) {\n"
          ],
          [
            "span",
            "frame",
            {
              "dataFrameType": "focus-unfocused",
              "dataFrameIndent": 0
            },
            "  let id = React.useId();\n  if (idProp) {\n    id = idProp;\n  }\n  return (\n    <BaseNumberField.Root\n      {...other}\n      render={(props, state) => (\n        <FormControl\n          size={size}\n          ref={props.ref}\n          disabled={state.disabled}\n          required={state.required}\n          error={error}\n          variant=\"outlined\"\n          sx={{\n            '& .MuiButton-root': {\n              borderColor: 'divider',\n              minWidth: 0,\n              bgcolor: 'action.hover',\n              '&:not(.Mui-disabled)': {\n                color: 'text.primary',\n              },\n            },\n          }}\n        >\n          {props.children}\n        </FormControl>\n      )}\n    >\n      <BaseNumberField.ScrubArea\n        render={\n          <Box component=\"span\" sx={{ userSelect: 'none', width: 'max-content' }} />\n        }\n      >\n        <FormLabel\n          htmlFor={id}\n          sx={{\n            display: 'inline-block',\n            cursor: 'ew-resize',\n            fontSize: '0.875rem',\n            color: 'text.primary',\n            fontWeight: 500,\n            lineHeight: 1.5,\n            mb: 0.5,\n          }}\n        >\n          {label}\n        </FormLabel>\n        <BaseNumberField.ScrubAreaCursor>\n          <OpenInFullIcon\n            fontSize=\"small\"\n            sx={{ transform: 'translateY(12.5%) rotate(45deg)' }}\n          />\n        </BaseNumberField.ScrubAreaCursor>\n      </BaseNumberField.ScrubArea>\n      <Box sx={{ display: 'flex' }}>\n        <BaseNumberField.Decrement\n          render={\n            <Button\n              variant=\"outlined\"\n              aria-label=\"Decrease\"\n              size={size}\n              sx={{\n                borderTopRightRadius: 0,\n                borderBottomRightRadius: 0,\n                borderRight: '0px',\n                '&.Mui-disabled': {\n                  borderRight: '0px',\n                },\n              }}\n            />\n          }\n        >\n          <RemoveIcon fontSize={size} />\n        </BaseNumberField.Decrement>\n\n        <BaseNumberField.Input\n          id={id}\n          render={(props, state) => (\n            <OutlinedInput\n              inputRef={props.ref}\n              value={state.inputValue}\n              onBlur={props.onBlur}\n              onChange={props.onChange}\n              onKeyUp={props.onKeyUp}\n              onKeyDown={props.onKeyDown}\n              onFocus={props.onFocus}\n              slotProps={{\n                input: {\n                  ...props,\n                  size:\n                    Math.max(\n                      (other.min?.toString() || '').length,\n                      state.inputValue.length || 1,\n                    ) + 1,\n                  sx: {\n                    textAlign: 'center',\n                  },\n                },\n              }}\n              sx={{ pr: 0, borderRadius: 0, flex: 1 }}\n            />\n          )}\n        />\n\n        <BaseNumberField.Increment\n          render={\n            <Button\n              variant=\"outlined\"\n              aria-label=\"Increase\"\n              size={size}\n              sx={{\n                borderTopLeftRadius: 0,\n                borderBottomLeftRadius: 0,\n                borderLeft: '0px',\n                '&.Mui-disabled': {\n                  borderLeft: '0px',\n                },\n              }}\n            />\n          }\n        >\n          <AddIcon fontSize={size} />\n        </BaseNumberField.Increment>\n      </Box>\n    </BaseNumberField.Root>\n  );\n"
          ],
          [
            "span",
            "frame",
            "}\n"
          ]
        ],
        "totalLines": 151,
        "focusedLines": 0,
        "collapsible": true,
        "language": "tsx",
        "source": {
          "type": "root",
          "children": [
            {
              "type": "element",
              "tagName": "span",
              "properties": {
                "className": [
                  "frame"
                ]
              },
              "children": [
                {
                  "type": "text",
                  "value": "import * as React from 'react';\nimport { NumberField as BaseNumberField } from '@base-ui/react/number-field';\nimport Box from '@mui/material/Box';\nimport Button from '@mui/material/Button';\nimport FormControl from '@mui/material/FormControl';\nimport FormLabel from '@mui/material/FormLabel';\nimport AddIcon from '@mui/icons-material/Add';\nimport RemoveIcon from '@mui/icons-material/Remove';\nimport OutlinedInput from '@mui/material/OutlinedInput';\nimport OpenInFullIcon from '@mui/icons-material/OpenInFull';\n\nexport default function NumberSpinner({\n  id: idProp,\n  label,\n  error,\n  size = 'medium',\n  ...other\n}: BaseNumberField.Root.Props & {\n  label?: React.ReactNode;\n  size?: 'small' | 'medium';\n  error?: boolean;\n}) {\n"
                }
              ]
            },
            {
              "type": "element",
              "tagName": "span",
              "properties": {
                "dataFrameType": "focus-unfocused",
                "dataFrameIndent": 0,
                "className": [
                  "frame"
                ]
              },
              "children": [
                {
                  "type": "text",
                  "value": "  let id = React.useId();\n  if (idProp) {\n    id = idProp;\n  }\n  return (\n    <BaseNumberField.Root\n      {...other}\n      render={(props, state) => (\n        <FormControl\n          size={size}\n          ref={props.ref}\n          disabled={state.disabled}\n          required={state.required}\n          error={error}\n          variant=\"outlined\"\n          sx={{\n            '& .MuiButton-root': {\n              borderColor: 'divider',\n              minWidth: 0,\n              bgcolor: 'action.hover',\n              '&:not(.Mui-disabled)': {\n                color: 'text.primary',\n              },\n            },\n          }}\n        >\n          {props.children}\n        </FormControl>\n      )}\n    >\n      <BaseNumberField.ScrubArea\n        render={\n          <Box component=\"span\" sx={{ userSelect: 'none', width: 'max-content' }} />\n        }\n      >\n        <FormLabel\n          htmlFor={id}\n          sx={{\n            display: 'inline-block',\n            cursor: 'ew-resize',\n            fontSize: '0.875rem',\n            color: 'text.primary',\n            fontWeight: 500,\n            lineHeight: 1.5,\n            mb: 0.5,\n          }}\n        >\n          {label}\n        </FormLabel>\n        <BaseNumberField.ScrubAreaCursor>\n          <OpenInFullIcon\n            fontSize=\"small\"\n            sx={{ transform: 'translateY(12.5%) rotate(45deg)' }}\n          />\n        </BaseNumberField.ScrubAreaCursor>\n      </BaseNumberField.ScrubArea>\n      <Box sx={{ display: 'flex' }}>\n        <BaseNumberField.Decrement\n          render={\n            <Button\n              variant=\"outlined\"\n              aria-label=\"Decrease\"\n              size={size}\n              sx={{\n                borderTopRightRadius: 0,\n                borderBottomRightRadius: 0,\n                borderRight: '0px',\n                '&.Mui-disabled': {\n                  borderRight: '0px',\n                },\n              }}\n            />\n          }\n        >\n          <RemoveIcon fontSize={size} />\n        </BaseNumberField.Decrement>\n\n        <BaseNumberField.Input\n          id={id}\n          render={(props, state) => (\n            <OutlinedInput\n              inputRef={props.ref}\n              value={state.inputValue}\n              onBlur={props.onBlur}\n              onChange={props.onChange}\n              onKeyUp={props.onKeyUp}\n              onKeyDown={props.onKeyDown}\n              onFocus={props.onFocus}\n              slotProps={{\n                input: {\n                  ...props,\n                  size:\n                    Math.max(\n                      (other.min?.toString() || '').length,\n                      state.inputValue.length || 1,\n                    ) + 1,\n                  sx: {\n                    textAlign: 'center',\n                  },\n                },\n              }}\n              sx={{ pr: 0, borderRadius: 0, flex: 1 }}\n            />\n          )}\n        />\n\n        <BaseNumberField.Increment\n          render={\n            <Button\n              variant=\"outlined\"\n              aria-label=\"Increase\"\n              size={size}\n              sx={{\n                borderTopLeftRadius: 0,\n                borderBottomLeftRadius: 0,\n                borderLeft: '0px',\n                '&.Mui-disabled': {\n                  borderLeft: '0px',\n                },\n              }}\n            />\n          }\n        >\n          <AddIcon fontSize={size} />\n        </BaseNumberField.Increment>\n      </Box>\n    </BaseNumberField.Root>\n  );\n"
                }
              ]
            },
            {
              "type": "element",
              "tagName": "span",
              "properties": {
                "className": [
                  "frame"
                ]
              },
              "children": [
                {
                  "type": "text",
                  "value": "}\n"
                }
              ]
            }
          ],
          "data": {
            "totalLines": 151,
            "focusedLines": 0,
            "collapsible": true
          }
        }
      }
    }
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
